export default __webpack_public_path__ + "static/media/Background_00281.c3d4ae48.png";